<template>
	<div class="date-picker">
		<div class="header">
			<div class="prev" @click="prev()">Forrige</div>
			<div v-if="collapsed" class="label" @click="toggle()">{{ day }}. {{ months[month] }}, {{ year }}</div>
			<div v-if="!collapsed" class="label" @click="toggle()">{{ months[month] }}, {{ year }}</div>
			<div class="next" @click="next()">Næste</div>
		</div>
		<div class="calendar" v-if="!collapsed">
			<div v-for="(week, idx) in weeks" :key="idx">
				<div @click="setDay(weekday)" :class="weekday == day ? 'active' : ''" v-for="(weekday, idx) in week" :key="idx">{{ weekday }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			months: {
				type: Array,
				default: function () {
					return [
						'januar',
						'februar',
						'marts',
						'april',
						'maj',
						'juni',
						'juli',
						'august',
						'september',
						'oktober',
						'november',
						'december',
					];
				}
			},
			days: {
				type: Array,
				default: function () {
					return [
						'mandag',
						'tirsdag',
						'onsdag',
						'torsdag',
						'fredag',
						'lørdag',
						'søndag'
					];
				}
			},
			uDays: {
				type: Array,
				default: function () {
					return [
						'man',
						'tir',
						'ons',
						'tor',
						'fre',
						'lør',
						'søn'
					];
				}
			},
			firstDayOfWeek: {
				type: Number,
				default: 1 // Monday
			}
		},
		data: function () {
			return {
				collapsed: false,
				day: 1,
				month: 1,
				year: 1
			};
		},
		computed: {
			weeks: function () {
				var wk = [];
				var wks = [];
				var d = this.getDate();
				var m = d.getMonth();

				d.setDate(1);

				var nDaysBefore = this.getNormalizedDay(d.getDay());

				for (var i = 0; i < nDaysBefore; ++i) {
					wk.push('');
				}

				i = 0;

				while (m == d.getMonth() && i < 50) {
					wk.push(d.getDate());
					d.setDate(d.getDate() + 1);

					if (nDaysBefore + i % 7 == 6) {
						wks.push(wk);
						wk = [];
					}

					++i;
				}

				if (wk.length > 0) {
					wks.push(wk);
				}

				return wks;
			}
		},
		created: function () {
			this.setDate(new Date());
		},
		methods: {
			getNormalizedDay(day) {
				return (day + (7 - this.firstDayOfWeek)) % 7;
			},
			getDateString() {
				var str = this.year;
				str += (this.month < 9 ? '-0' : '-') + (this.month + 1);
				str += (this.day < 10 ? '-0' : '-') + this.day;

				return str;
			},
			setDate(d) {
				this.day = d.getDate();
				this.month = d.getMonth();
				this.year = d.getFullYear();

				this.$emit('change', this.getDateString());
			},
			setDay(d) {
				var dt = this.getDate();
				dt.setDate(d);
				this.setDate(dt);
			},
			getDate() {
				return new Date(this.year, this.month, this.day);
			},
			prev() {
				console.log('prev');

				var d = this.getDate();

				if (this.collapsed) {
					d.setDate(d.getDate() - 1);
				} else {
					d.setMonth(d.getMonth() - 1);
				}

				this.setDate(d);
			},
			next() {
				console.log('next');

				var d = this.getDate();

				if (this.collapsed) {
					d.setDate(d.getDate() + 1);
				} else {
					d.setMonth(d.getMonth() + 1);
				}

				this.setDate(d);
			},
			toggle() {
				console.log('toggle');
				this.collapsed = !this.collapsed;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.header {
		display: grid;
		grid-template-columns: 100px auto 100px;
		height: 100%;
	}

	.prev, .next, .label {
		text-align: center;
		line-height: 60px;
		cursor: pointer;
	}

	.prev, .next {
		text-transform: uppercase;
		font-size: 12px;
	}

	.calendar > div {
		display: grid;
		column-gap: auto;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	}

	.calendar > div > div {
		text-align: center;
		line-height: 56px;
	}

	.calendar > div > div.active {
		background: white;
		color: black;
		border-radius: 50%;
	}
</style>